import * as React from "react";
import * as ReactDOM from "react-dom";
import {Widget} from "./components/widget/widget"

var widgetElements = document.querySelectorAll("#NCB-datepicker-widget");

if (widgetElements.length > 0) {

    let useIndex = 0;
    for (let i=0; widgetElements.length > i; i++) {
        let op = (widgetElements[i] as any).offsetParent;
        
        if (op != null)
            useIndex = i;
    }

    let widgetElement = widgetElements[useIndex] as any;

    let numAdults: number = widgetElement.dataset.adults == null ? null : parseInt(widgetElement.dataset.adults);

    let action: string = widgetElement.dataset.action;
    let startDate: string = widgetElement.dataset.startdate;
    let endDate: string = widgetElement.dataset.enddate;
    
    ReactDOM.render(
        <Widget 
            promotionCode={widgetElement.dataset.promotioncode}
            hidePromotionCode={widgetElement.dataset.hidePromotioncode === "true"}
            roomTypeCodeFilter={widgetElement.dataset.room}
            showPriceCalendar={( widgetElement.dataset.showPriceCalendar === "true" || action === 'show_price_calendar')}
            showTotalPrice={( widgetElement.dataset.showTotalPrice === "true" )}
            rate={widgetElement.dataset.rate}
            ratePlanOrGroupCode={widgetElement.dataset.rate}
            adults={isNaN(numAdults) ? 1 : numAdults}
            showCampaignCodeInline={widgetElement.dataset.inlinePromotionCode === "true"}
            action={action}
            startDate={startDate}
            endDate={endDate}
            />,
        widgetElement
    );
}




// WEBPACK FOOTER //
// ./src/widget.index.tsx